import { useState } from 'react';
import { CalendarDays, ChevronLeft, ChevronRight } from 'lucide-react';
import { Button } from '@verlo/shared/components/ui/button';
import { Calendar } from '@verlo/shared/components/ui/calendar';
import { Popover, PopoverContent, PopoverTrigger } from '@verlo/shared/components/ui/popover';
import { mondayOf, weekWords } from '../../lib/weeks';

// The week arrows, and between them the week itself: a button that opens a month calendar
// to jump to any week (D6). Days before `earliest` (the first rota) are greyed.
export default function WeekPicker({ weekStart, onChange, earliest, testId = 'week-picker' }) {
  const [open, setOpen] = useState(false);
  const step = (days) => { const d = new Date(weekStart); d.setDate(d.getDate() + days); onChange(d); };
  const weekEnd = new Date(weekStart);
  weekEnd.setDate(weekEnd.getDate() + 6);
  return (
    <div className="flex items-center gap-1" data-testid={testId}>
      <Button variant="outline" size="icon" className="h-9 w-9" onClick={() => step(-7)} aria-label="Previous week" data-testid={`${testId}-prev`}>
        <ChevronLeft size={16} />
      </Button>
      <Popover open={open} onOpenChange={setOpen}>
        <PopoverTrigger asChild>
          <Button variant="outline" className="h-9 gap-2 tabular-nums" data-testid={`${testId}-open`}>
            <CalendarDays size={15} className="text-ink-soft" />
            {weekWords(weekStart)}
          </Button>
        </PopoverTrigger>
        <PopoverContent align="center" className="w-auto p-0">
          <Calendar
            mode="range"
            weekStartsOn={1}
            selected={{ from: weekStart, to: weekEnd }}
            defaultMonth={weekStart}
            disabled={earliest ? { before: earliest } : undefined}
            onDayClick={(day) => { onChange(mondayOf(day)); setOpen(false); }}
          />
        </PopoverContent>
      </Popover>
      <Button variant="outline" size="icon" className="h-9 w-9" onClick={() => step(7)} aria-label="Next week" data-testid={`${testId}-next`}>
        <ChevronRight size={16} />
      </Button>
    </div>
  );
}
